import React, { useContext, useEffect, useState } from 'react';
import SingleSlider from '../SingleSlider';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../components/navbar/Footer';
import { StepsContext } from '../../../context/stepsContext';
import useFetch from '../../../hooks/useFetch';
import axios from 'axios';
import Pickles from '../../../components/particles/Pickles';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';
export default function StepOne({ minutesDisplay, secondsDisplay }) {
  const [pickle, setPickle] = useState(false);
  const { dispatch, start } = useContext(StepsContext);
  const navigate = useNavigate();

  const { state: firstState } = useLocation();
  const { state: temp } = firstState ? firstState : '';
  const state = temp ? temp : '';
  const { survey_id } = firstState ? firstState : '';
  const { personType } = firstState ? firstState : '';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { loading } = useFetch(
    `${process.env.REACT_APP_BASE_URL}/survey/getSurveyDetails/${survey_id}`
  );

  const [newArray, setNewArray] = useState([]);

  useEffect(() => {
    let id = 1;
    const newArray = [];
    for (const key in state?.pqs) {
      if (state?.pqs.hasOwnProperty(key)) {
        newArray.push({
          id: id,
          key: key,
          title: state?.pqs[key],
          value: 65,
          altered: false,
        });
        id++;
      }
    }
    setNewArray(newArray);
  }, [state.pqs]);
  console.log(newArray);

  // Create an object from the newArray
  const newObj = {};
  newArray.forEach((item) => {
    newObj[item.key] = item.value;
  });
  newObj['survey_id'] = state?.project_id;
  newObj['member_id'] = state?.member_Id;
  newObj['person_type'] = personType;
  console.log(newObj);
  const [finalData, setFinalData] = useState({});

  useEffect(() => {
    !start && navigate('/pageNotfound');
  }, [start, navigate]);
  const handleClick = async () => {
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/survey/sendStep1Data`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: newObj,
    })
      .then(function (response) {
        console.log(response);
        setPickle(true);
        setTimeout(() => {
          setPickle(false);
          dispatch({ type: 'STEP' });
          navigate('/steptwo', {
            state: {
              state: response.data,
              stepone: newObj,
              survey_id: survey_id,
              personType: personType,
            },
          });
        }, 1000);

        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  console.log(finalData);
  let Altered = newArray.some((obj) => obj.altered === false);

  return (
    <div className="mainContainer">
      <Navbar
        special={
          REACT_APP_SURVEY_ID === survey_id ||
          REACT_APP_SURVEY_ID_ER === survey_id
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />
      {pickle && <Pickles />}
      <div className="surveys-sub-container">
        <Steps
          er={REACT_APP_SURVEY_ID_ER === survey_id}
          step={1}
          active={true}
        />
        <div className="inst-c">
          <div className="survey-slider-container-title surveys-question-title">
            {REACT_APP_SURVEY_ID_ER === survey_id
              ? "We'd like to start by understanding your experience. Move each slider to show how much you agree or disagree with each of these statements. There are 12 to complete."
              : "We'd like to start by understanding your wellbeing experience. Move each slider to show how much you agree or disagree with each of these statements. There are 12 to complete."}
          </div>
          <div style={{ color: 'red' }}>
            <ul>
              <li>
                * A score of 100 means you totally agree and 0 means you totally
                disagree.
              </li>
            </ul>
          </div>
        </div>
        <div className="survey-slider-container inst-sub-first">
          <div className="slider-all">
            {newArray?.map((value) => (
              <SingleSlider
                loading={loading}
                setFinalData={setFinalData}
                key={value.id}
                value={value}
                values={newArray}
                setValues={setNewArray}
              />
            ))}
          </div>
        </div>
        <div className="btn-container">
          {/* <Link to={'/steptwo'}> */}
          <Button
            // disabled={Altered}
            onClick={handleClick}
            className="signupCVbtnSign"
            type="submit"
            variant="contained"
            style={{
              backgroundColor: Altered ? '' : '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Next
          </Button>
          {/* </Link> */}
        </div>
        <Footer />
      </div>
    </div>
  );
}
